import { render, staticRenderFns } from "./new_cnab_remittance.vue?vue&type=template&id=f3665872&scoped=true&"
import script from "./new_cnab_remittance.vue?vue&type=script&lang=js&"
export * from "./new_cnab_remittance.vue?vue&type=script&lang=js&"
import style0 from "./new_cnab_remittance.vue?vue&type=style&index=0&id=f3665872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3665872",
  null
  
)

export default component.exports